import { z } from 'zod'
import { UlcerItem } from '../ulcer/UlcerItem'

// updating this model?  don't break current data!
// see _UpdatingSchemas.md
export const RUlcerReviewItem = z.object({
	ulcerType: z.string(),
	sites: z.string(),
	stage: z.string(),
	icdCode: z.string(),
})

export type UlcerReviewItem = z.infer<typeof RUlcerReviewItem>

export const newUlcerReviewItem = (
	ulcerType: string = '', 
	sites: string = '',
	stage: string = '',
	icdCode: string = '',
): UlcerReviewItem => {
	return {
		ulcerType,
		sites,
		stage,
		icdCode
	}
}

export const getUlcerTypes = (mappings: UlcerItem[]) => {
	const unique = [
		...new Set([...mappings.map(x => x.UlcerType)])
	]

	return unique
}

export const getSitesForUlcerType = (ulcerType: string, mappings: UlcerItem[]) => {
	return [
		...new Set([...mappings.filter(mapping => mapping.UlcerType === ulcerType).map(mapping => mapping.UlcerSite)])
	] 
}

export const getStageForSiteAndUlcerType = (ulcerType: string, site: string, mappings: UlcerItem[]) => {
	return mappings.filter(mapping => mapping.UlcerSite === site && mapping.UlcerType === ulcerType)
		.map(m => m.UlcerStage)
}

export const getIcdCodeForUlcer = (ulcerType: string, site: string, stage: string, mappings: UlcerItem[]) => {
	return mappings.find(mapping => 
		mapping.UlcerType === ulcerType &&
		mapping.UlcerSite === site &&
		mapping.UlcerStage === stage
	)?.ICD10_1
}

export const ulcerReviewItemIsValid = (item: UlcerReviewItem) => {
	return item.icdCode &&
		item.sites &&
		item.stage &&
		item.ulcerType
}